import { useContext } from 'react';
import { DeleteModal, ModalContext } from 'dash-ui';

import {
  GetOrganizationUsersForTableDocument,
  useDeleteOrganizationUserMutation,
} from 'gql/generated.graphql';
import { OrganizationUsersModalsEnum } from '../../constants/constants';

function DeleteOrganizationUserModal() {
  const { payload } = useContext(ModalContext);

  const [deleteUser, { loading }] = useDeleteOrganizationUserMutation({
    refetchQueries: [GetOrganizationUsersForTableDocument],
  });

  async function submitUserOrgDelete() {
    await deleteUser({ variables: {
      organizationUserId: payload?.organizationUserId,
    } });
  }

  return (
    <DeleteModal
      entity="Organization User"
      name={payload?.userName}
      isLoading={loading}
      modalName={OrganizationUsersModalsEnum.DELETE_ORGANIZATION_USER}
      onClick={submitUserOrgDelete}
    />
  );
}

export default DeleteOrganizationUserModal;
